import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "vui-rich-text-container, [vui-rich-text-container]",
    template: "<ng-content />",
    styleUrl: "rich-text-container.component.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "vui-rich-text-container"
    }
})
export class RichTextContainerComponent {}
